import { getEnvOnly } from "./Meet";

export default {
  setItem(name, data) {
    const lsPrefix = getEnvOnly()?.VUE_APP_LS_PREFIX;
    return localStorage.setItem(`${lsPrefix}${name}`, JSON.stringify(data));
  },
  removeItem(name) {
    const lsPrefix = getEnvOnly()?.VUE_APP_LS_PREFIX;
    return localStorage.removeItem(`${lsPrefix}${name}`);
  },
  getItem(name) {
    const lsPrefix = getEnvOnly()?.VUE_APP_LS_PREFIX;
    let value = localStorage.getItem(`${lsPrefix}${name}`);
    try {
      value = JSON.parse(value);
      // eslint-disable-next-line no-empty
    } catch (error) {}
    return value;
  }
};
